
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rules/[...slug]",
      function () {
        return require("private-next-pages/rules/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rules/[...slug]"])
      });
    }
  